import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

const KEY = "bn_privacy_consent";

export const CookieBanner = () => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setShow(true), 1400);
            return () => clearTimeout(t);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(KEY, "accepted");
        setShow(false);
    };

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    data-testid="cookie-privacy-banner"
                    initial={{ opacity: 0, y: 60 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 60 }}
                    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                    className="fixed bottom-4 inset-x-4 sm:bottom-6 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60]"
                >
                    <div className="bg-[#0B0F17]/95 backdrop-blur-xl border border-bn-blue/30 rounded-2xl p-6 shadow-[0_25px_60px_rgba(0,0,0,0.6)]">
                        <div className="flex items-center gap-2.5 mb-3">
                            <ShieldCheck className="w-5 h-5 text-bn-blue" />
                            <h3 className="font-display font-bold text-white">Your Privacy Matters</h3>
                        </div>
                        <p className="text-sm text-slate-400 leading-relaxed">
                            We use cookies to improve your experience, remember your preferences and understand how the site is used. By accepting, you agree to our use of cookies as described in our Privacy Policy.
                        </p>
                        <div className="mt-5 flex items-center gap-3">
                            <button
                                data-testid="cookie-accept-all-button"
                                onClick={accept}
                                className="flex-1 py-3 rounded-full bg-bn-blue hover:bg-bn-bluehover text-white text-sm font-semibold tracking-wide transition-all duration-300"
                            >
                                ACCEPT
                            </button>
                            <button
                                data-testid="cookie-privacy-policy-button"
                                onClick={() => { accept(); navigate("/privacy-policy"); }}
                                className="flex-1 py-3 rounded-full border border-white/15 hover:border-bn-blue/60 text-slate-300 hover:text-white text-sm font-semibold tracking-wide transition-all duration-300"
                            >
                                PRIVACY POLICY
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
